import { render, staticRenderFns } from "./muGuang.vue?vue&type=template&id=3eca0c6a"
import script from "./muGuang.vue?vue&type=script&lang=js"
export * from "./muGuang.vue?vue&type=script&lang=js"
import style0 from "./muGuang.vue?vue&type=style&index=0&id=3eca0c6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports